export const nultiSelectStyles = {
  control: (provided) => ({
    ...provided,
    border: 'none',
    height: '32px',
    minHeight: 'unset',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: 'white',
    fontSize: '17px',
  }),
  clearIndicator: (provided) => ({
    ...provided,
    color: 'black',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: 'black',
  }),
  menuList: (provided) => ({
    ...provided,
    backgroundColor: '#e4e6e6',
    padding: '10px 20px',
  }),
  option: (provided) => ({
    ...provided,
    lineHeight: '1.4',
    borderRadius: '0.5rem',
    padding: '2px',
    backgroundColor: 'none',
    '&:hover': {
      backgroundColor: '#adb2b4',
      color: 'white',
    },
  }),
};
